import React from 'react';
import { Text } from '../atom/Text';

export const TextWithTagToBr = (text) => {
  return text.split('\n').map((line, index) => {
    return (
      <Text size={12} key={index} lineHeight="1.5">
        {line}
        <br />
      </Text>
    );
  });
};
